(function ( $ ) {
    var dropdownOptionsHoverObject = {};
    $.fn.dropdownOptions = function(options) {
        $(this).each(function() {
            const elm = $(this);
            elm.bind('click.dropdownOptions',function(e){
                e.preventDefault();
                let elm = $(this);

                if(options === undefined && elm.is('[data-dropdown-options]')) {
                    options = JSON.parse(atob(elm.attr('data-dropdown-options')));
                }

                let container = elm.parent();
                if (!container.hasClass('dropdown-options-button-container')) {
                    const w = elm.width();
                    const h = elm.height();
                    const id = get_unique_id();
                    elm.after('<div class="dropdown-options-button-container" id="'+id+'"></div>');
                    const clone = elm.clone(true,true);
                    elm.next().html(clone);
                    elm.hide();
                    container = $('.dropdown-options-button-container#'+id);
                    elm = $('.dropdown-options-button-container#'+id+' > *');
                    elm.show();
                    container.css({
                        'width': w,
                        'height': h
                    });
                }



                let wrapper = elm.next();
                if (!wrapper.hasClass('dropdown-options-wrapper')) {
                    elm.after('<div class="dropdown-options-wrapper" style="display: none;"><ul></ul></div>');
                    wrapper = container.find('.dropdown-options-wrapper');
                    const leftOffset = elm.offset().left;

                    const side = leftOffset > ($(window).width()/2) ? 'right' : 'left';
                    wrapper.attr('data-side',side);

                    if(options !== undefined) {
                        let set_options = () => {};
                        set_options = (container, options) => {
                            for(let key in options) {
                                const option = options[key];
                                const type = !option.action ? 'verbose' : (typeof option.action === 'function' ? 'function' : option.action.split('(').length > 1 ? 'js' : 'url');
                                if(type === 'verbose') {
                                    container.append('<li><a href="#">'+option.title+'</a></li>');
                                } else if(type === 'js') {
                                    container.append('<li><a href="#" onclick="return '+option.action+';">'+option.title+'</a></li>');
                                } else if (type === 'url') {
                                    container.append('<li><a href="'+option.action+'">'+option.title+'</a></li>');
                                } else {
                                    const a = $(`<a>${option.title}</a>`);

                                    a.click(option.action);

                                    const li = $('<li></li>');
                                    li.html(a);
                                    container.append(li);
                                }
                                if(option.options) {
                                    container.find('li:last').append('<ul></ul>');
                                    set_options(container.find('li:last ul'), option.options);
                                }
                            }
                        };
                        set_options(wrapper.find('ul'), options);
                    }
                }
                wrapper.toggle();
                wrapper.toggleClass('shown', wrapper.is(':visible'));

                wrapper.unbind('mousemove').mousemove(function() {
                    if (wrapper[0]['timeout']) {
                        clearTimeout(wrapper[0]['timeout']);
                    }
                });

                wrapper.unbind('mouseleave').mouseleave(function() {
                    const wrapper = $(this);
                    if (wrapper[0]['timeout']) {
                        clearTimeout(wrapper[0]['timeout']);
                    }
                    wrapper[0]['timeout'] = setTimeout(() => {
                        elm.click();
                    }, 2000);
                });


                // setTimeout(function() {
                //     wrapper.addClass('shown');
                // },100);
                //
                // dropdownOptionsHoverObject[container.attr('id')] = false;
                //
                // const close_dropdown = (elm, timeout) => {
                //     if(timeout === undefined) {
                //         timeout = 0;
                //     }
                //     const container = elm.parent();
                //     dropdownOptionsHoverObject[container.attr('id')] = setTimeout(() => {
                //         container.find('.dropdown-options-wrapper').removeClass('shown');
                //         const hide_time = 500 + container.find('li').length * 100;
                //         setTimeout(function() {
                //             container.find('.dropdown-options-wrapper').hide();
                //         }.bind(container),hide_time);
                //     },timeout);
                // };
                // close_dropdown(wrapper, 2500);
                //
                // wrapper.unbind('mouseenter mousemove').bind('mouseenter mousemove', function() {
                //     clearTimeout(dropdownOptionsHoverObject[$(this).parent().attr('id')]);
                // }).unbind('mouseleave').mouseleave(function() {
                //     setTimeout(() => {
                //         close_dropdown($(this),2500);
                //     }, 500);
                // }).unbind('click').click(function() {
                //     close_dropdown($(this));
                // });
            });
        });
        return this;
    };

}( jQuery ));
